import { useEffect } from 'react';

export default function useScrollReveal(ref, options = {}) {
  const threshold = options.threshold ?? 0.15;
  const rootMargin = options.rootMargin ?? '0px';
  const triggerOnce = options.triggerOnce ?? true;

  useEffect(() => {
    const container = (ref && ref.current) ? ref.current : document.body;
    if (!container) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            if (triggerOnce) {
              obs.unobserve(entry.target);
            }
          }
        });
      },
      { threshold, rootMargin }
    );

    const revealElements = container.querySelectorAll('.reveal');
    revealElements.forEach((el) => observer.observe(el));

    return () => {
      observer.disconnect();
    };
  });
}
